import { Grid, Typography } from '@mui/material'
import React from 'react'
import { formatDate } from '../../../assets/library';

const Preference = (props:any) => {
  const data = [
    {
      key: "Degree",
      label: props?.data?.degree? props?.data?.degree:"N/A",
    },
    {
      key: "Start date / Intake",
      label: props?.data?.intake ? formatDate(props?.data?.intake,true):"N/A",
    },
    {
      key: "Budget",
      label: props?.data?.budget?.upper&& props?.data?.budget?.lower ? props?.data?.budget?.upper + "-" + props?.data?.budget?.lower : "N/A" ,
    },
    {
      key: "Country",
      label: props?.data?.country.map((item:string)=>item + " , "),
    },
    {
      key: "Sub disciplines",
      label: props?.data?.courses.map((item:string)=>item + " , "),
    },
  ];
  
  return (
    <div>
      <Typography sx={{background:"#FCF1EE",width:"fit-content",p:1,borderRadius:"10px",mb:2}}>Preferences & Skills</Typography>
      <Grid container sx={{ boxShadow: 3, p: 2, borderRadius: "10px",mb:2 }}>
        {data?.map((item,i) => (
          <Grid item xs={6} sx={{ display: "flex", p: 1 }} key={i}>
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    minWidth: 150,
                    color: "#7C7A7A",
                    fontSize: "14px",
                  }}
                >
                  {item.key}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{item.label}</Typography>
              </Grid>
            </Grid>
          </Grid>

        ))}
        <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    minWidth: 150,
                    color: "#7C7A7A",
                    fontSize: "14px",
                  }}
                >
                  Skills
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{props?.skills?.map((item:string)=>item + " , ")}</Typography>
              </Grid>
            </Grid>
          </Grid>
      </Grid>
      
    </div>
  )
}

export default Preference